// extracted by mini-css-extract-plugin
export default {"langBtnGroup":"LanguageSwitcher_langBtnGroup__A-lwn","langBtn":"LanguageSwitcher_langBtn__dSmjw","langMenu":"LanguageSwitcher_langMenu__YI7Rd"};